function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Proposition } from '../config/internal-config';
import { sdkLogger } from '../logger';
import { getDefaultDevicePlayerMap } from './default-device-player-map';
/** Sets total playback duration as only asset duration, not asset duration + ad duration (Chromecast default) */ /**
     * If true, queue item will be prefetched when the previous queue item is nearing completion
     */ /** When enabled, text tracks will be normalized with 3-letter language codes */ /**
 * @public
 */ // will pass proposition specific config for addons (e.g. reporting tag adapters )
// will pass proposition specific config for ovp (e.g ovp data adapter)
// will pass proposition specific config for players
// used for comparisons to enable high rate playback
/** Enables support for max video format downgrades during robustness failures */ // Exclude is temporary until the device library is updated
/**
 * @public
 */ export function loadPropositionExtensions(p, internalConfigPerPlaybackType, device) {
    return _loadPropositionExtensions.apply(this, arguments);
}
function _loadPropositionExtensions() {
    _loadPropositionExtensions = _async_to_generator(function(p, internalConfigPerPlaybackType, device) {
        var e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        propositionExtensions[p].loadExtensions(internalConfigPerPlaybackType, device)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    sdkLogger.error("loadPropositionExtensions: failed to get extensions for proposition ".concat(p, "."));
                    throw e;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _loadPropositionExtensions.apply(this, arguments);
}
export var getDevicePlayerMap = function(proposition, deviceInfo, deviceType) {
    if (!propositionExtensions[proposition]) {
        sdkLogger.warn("getDevicePlayerMap: map for proposition ".concat(proposition, " is not found. Using default map."));
        return getDefaultDevicePlayerMap(deviceInfo);
    }
    return propositionExtensions[proposition].getDevicePlayerMap(deviceInfo, deviceType);
};
var _obj;
var propositionExtensions = (_obj = {}, _define_property(_obj, Proposition.OneApp, {
    getDevicePlayerMap: getDefaultDevicePlayerMap,
    loadExtensions: loadOneAppExtensions
}), _define_property(_obj, Proposition.Peacock, {
    getDevicePlayerMap: getDefaultDevicePlayerMap,
    loadExtensions: loadPeacockExtensions
}), _define_property(_obj, Proposition.Showmax, {
    getDevicePlayerMap: getDefaultDevicePlayerMap,
    loadExtensions: loadShowmaxExtensions
}), _define_property(_obj, Proposition.NOWOTT, {
    getDevicePlayerMap: getDefaultDevicePlayerMap,
    loadExtensions: loadNowExtensions
}), _define_property(_obj, Proposition.SkyStore, {
    getDevicePlayerMap: getDefaultDevicePlayerMap,
    loadExtensions: loadSkyStoreExtensions
}), _define_property(_obj, Proposition.SkyShowtime, {
    getDevicePlayerMap: getDefaultDevicePlayerMap,
    loadExtensions: loadSkyShowtimeExtensions
}), _define_property(_obj, Proposition.NBC, {
    getDevicePlayerMap: getDefaultDevicePlayerMap,
    loadExtensions: loadNBCExtensions
}), _obj);
function loadOneAppExtensions(config, device) {
    return _loadOneAppExtensions.apply(this, arguments);
}
function _loadOneAppExtensions() {
    _loadOneAppExtensions = _async_to_generator(function(config, device) {
        var load;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ext-oneapp" */ './oneapp/loader')
                    ];
                case 1:
                    load = _state.sent().load;
                    return [
                        2,
                        load(config, device)
                    ];
            }
        });
    });
    return _loadOneAppExtensions.apply(this, arguments);
}
function loadPeacockExtensions(config, device) {
    return _loadPeacockExtensions.apply(this, arguments);
}
function _loadPeacockExtensions() {
    _loadPeacockExtensions = _async_to_generator(function(config, device) {
        var load;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ext-peacock" */ './peacock/loader')
                    ];
                case 1:
                    load = _state.sent().load;
                    return [
                        2,
                        load(config, device)
                    ];
            }
        });
    });
    return _loadPeacockExtensions.apply(this, arguments);
}
function loadShowmaxExtensions(config, device) {
    return _loadShowmaxExtensions.apply(this, arguments);
}
function _loadShowmaxExtensions() {
    _loadShowmaxExtensions = _async_to_generator(function(config, device) {
        var load;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ext-showmax" */ './showmax/loader')
                    ];
                case 1:
                    load = _state.sent().load;
                    return [
                        2,
                        load(config, device)
                    ];
            }
        });
    });
    return _loadShowmaxExtensions.apply(this, arguments);
}
function loadSkyShowtimeExtensions(config, device) {
    return _loadSkyShowtimeExtensions.apply(this, arguments);
}
function _loadSkyShowtimeExtensions() {
    _loadSkyShowtimeExtensions = _async_to_generator(function(config, device) {
        var load;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ext-skyshowtime" */ './skyshowtime/loader')
                    ];
                case 1:
                    load = _state.sent().load;
                    return [
                        2,
                        load(config, device)
                    ];
            }
        });
    });
    return _loadSkyShowtimeExtensions.apply(this, arguments);
}
function loadNowExtensions(config, device) {
    return _loadNowExtensions.apply(this, arguments);
}
function _loadNowExtensions() {
    _loadNowExtensions = _async_to_generator(function(config, device) {
        var load;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ext-nowott" */ './nowott/loader')
                    ];
                case 1:
                    load = _state.sent().load;
                    return [
                        2,
                        load(config, device)
                    ];
            }
        });
    });
    return _loadNowExtensions.apply(this, arguments);
}
function loadSkyStoreExtensions(config, device) {
    return _loadSkyStoreExtensions.apply(this, arguments);
}
function _loadSkyStoreExtensions() {
    _loadSkyStoreExtensions = _async_to_generator(function(config, device) {
        var load;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ext-skystore" */ './skystore/loader')
                    ];
                case 1:
                    load = _state.sent().load;
                    return [
                        2,
                        load(config, device)
                    ];
            }
        });
    });
    return _loadSkyStoreExtensions.apply(this, arguments);
}
function loadNBCExtensions(config, device) {
    return _loadNBCExtensions.apply(this, arguments);
}
function _loadNBCExtensions() {
    _loadNBCExtensions = _async_to_generator(function(config, device) {
        var load;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ext-nbc" */ './nbc/loader')
                    ];
                case 1:
                    load = _state.sent().load;
                    return [
                        2,
                        load(config, device)
                    ];
            }
        });
    });
    return _loadNBCExtensions.apply(this, arguments);
}

//# sourceMappingURL=proposition-extensions.js.map